import React from "react";
import { Search } from "lucide-react";

interface SearchSubmitButtonProps {
  isInNavbar: boolean;
  label: string;
}

export function SearchSubmitButton({ isInNavbar, label }: SearchSubmitButtonProps) {
  return (
    <button
      type="submit"
      aria-label={label}
      tabIndex={isInNavbar ? undefined : -1}
      className={isInNavbar ? "text-muted-foreground/50 cursor-pointer px-3" : "sr-only"}
    >
      <Search size={24} aria-hidden="true" />
    </button>
  );
}
